/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import '../../css/event210621.css';

import { toast } from 'react-toastify'; //토스트(toast)
// import moment from "moment";
import axios from 'axios';

class ContentItem extends Component {
  state = {
    alram: this.props.childProps.alramFlag,
  };
  _goContent = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };

  _toggleAlram = async () => {
    const { loginId, history } = this.props;
    if (loginId === '' || loginId === null || loginId === undefined) {
      //toast.warn('로그인 후 이용해 주세요.')
      history.push('/login');
    } else {
      const result = await this._toggleAlramApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        alram: intReturn,
      });
      if (intReturn === 100) {
        toast.success(
          '알림 등록 성공~! 모바일 APP을 통해서만 알림을 받으실 수 있습니다.'
        );
      } else {
        toast.warn('알림 해제 성공~!');
      }
    }
  };
  _toggleAlramApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/alramToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  render() {
    const { contentSerial, img, comment, title } = this.props.childProps;
    const { imgUrl } = this.props;
    const { alram } = this.state;
    return (
      <Fragment>
        <li>
          <div className="thumb">
            <a
              onClick={() => this._goContent(contentSerial)}
              style={{ cursor: 'pointer' }}
            >
              <img src={img} />
            </a>
          </div>
          <div className="info" style={{ height: 115 }}>
            <p className="date">
              <img
                src={imgUrl + '/img/event/event210621/ico_live.png'}
                alt="LIVE"
              />{' '}
              {comment}
            </p>
            <p className="subject">
              <a
                onClick={() => this._goContent(contentSerial)}
                style={{ cursor: 'pointer' }}
              >
                {title}
              </a>
            </p>
          </div>
          <button
            onClick={this._toggleAlram}
            type="button"
            className={alram === 0 ? 'btnAlram' : 'btnAlram active'}
          >
            {alram === 0 ? '본방알림 받음' : '본방알림 취소'}
          </button>
        </li>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItem));
